"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strictParseInt = void 0;
const __1 = require("..");
/**
 * Parses a string representation of an integer.
 * An exception is thrown if an non-integer string is provided.
 * @returns the integer expressed by `formatted`
 * @todo This does not safely assert integer size
 */
function strictParseInt(formatted, radix = 10) {
    if (/^-?\d+$/.test(formatted)) {
        return parseInt(formatted, radix);
    }
    throw new __1.IllegalArgumentException(`'${formatted}' is not a valid integer string.`);
}
exports.strictParseInt = strictParseInt;
//# sourceMappingURL=#strict-parse-int.js.map